import i18next from 'i18next';
/**
 * Validates that all four TWC-required capture fields are populated.
 *
 * @param formValues - The current form values to validate.
 * @returns A FieldErrors object — empty when all fields are present, populated when any are missing.
 */
export function kinderConnectCaptureFormValuesValidator(formValues) {
    const result = {};
    if (!formValues.photoBase64) {
        result.photoBase64 = {
            type: 'required',
            message: i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.formErrors.photoRequired),
        };
    }
    if (!formValues.signatureBase64) {
        result.signatureBase64 = {
            type: 'required',
            message: i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.formErrors.signatureRequired),
        };
    }
    // Falsy check catches both undefined (before capture) and '' (cleared).
    // The string '0' is truthy so valid coordinate values like '0.0' are accepted.
    const locationRequiredMessage = i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.formErrors.locationRequired);
    if (!formValues.latitude) {
        result.latitude = { type: 'required', message: locationRequiredMessage };
    }
    if (!formValues.longitude) {
        result.longitude = { type: 'required', message: locationRequiredMessage };
    }
    return result;
}
